import './styles.css'
let currentYear = new Date().getFullYear();
let endpointPath = '/v1/employee-promo-users'

function handleFormSubmission(form) {
    const getFormFields = () => {
        return {
            termsAcceptedCheckbox: form.querySelector('input[type=checkbox]'),
            firstNameInput: form.querySelector('[name=first-name]'),
            lastNameInput: form.querySelector('[name=last-name]'),
            phoneNumberInput: form.querySelector('input[type=tel]'),
            submitButton: form.querySelector('button')
        };
    };

    const disableForm = fields => {
        const {firstNameInput, lastNameInput, phoneNumberInput, submitButton} = fields;
        [firstNameInput, lastNameInput, phoneNumberInput].forEach(field => {
            field.classList.add('semi-transparent');
            field.disabled = true;
        });

        submitButton.innerHTML = '<img src="images/spinner.png">';
        submitButton.disabled = true;

        form.querySelector('.check').classList.add('semi-transparent');
        form.querySelector('.check').disabled = true;
    };

    const enableForm = fields => {
        const {firstNameInput, lastNameInput, phoneNumberInput, submitButton} = fields;
        [firstNameInput, lastNameInput, phoneNumberInput].forEach(field => {
            field.classList.remove('semi-transparent');
            field.disabled = false;
        });

        submitButton.innerText = "Get Started";
        submitButton.disabled = false;

        form.querySelector('.check').classList.remove('semi-transparent');
        form.querySelector('.check').disabled = false;
    };

    const handleAjaxSuccess = (form, fields) => {
        form.querySelector(".error-notification").style.display = 'none';
        fields.submitButton.innerText = 'Sent!';
        fbq('track', 'Lead');
        gtag('event', 'conversion', {'send_to': 'AW-16446912316/GM76CJLg9aQZELzuv6I9'});
    };

    const handleAjaxError = (form, fields, response) => {
        let errorMessage;

        if (response.status === 422 || response.status === 403) {
            const content = JSON.parse(response.responseText);
            errorMessage = content.errors[0].message;
        } else if (response.status === 0) {
            errorMessage = 'There is communication issue detected. Please verify your network connection and try again'
        }

        form.querySelector(".error-notification").innerText = errorMessage;
        form.querySelector(".error-notification").style.display = 'block';

        enableForm(fields);
    };

    form.addEventListener('submit', event => {
        event.preventDefault();
        grecaptcha.ready(() => {
            grecaptcha.execute(settings.reCaptchaSitekey, {action: 'submit'})
                .then(token => {
                    const fields = getFormFields();

                    if (!fields.termsAcceptedCheckbox.checked) {
                        fields.termsAcceptedCheckbox.classList.add('forceCheck');
                        return;
                    }

                    const requestUrl = new URL(settings.url);
                    requestUrl.pathname = endpointPath;
                    requestUrl.search = window.location.search;

                    disableForm(fields);

                    $.ajax({
                        url: requestUrl.toString(),
                        type: 'POST',
                        contentType: 'application/json',
                        data: JSON.stringify({
                            FirstName: fields.firstNameInput.value,
                            LastName: fields.lastNameInput.value,
                            PhoneNumber: '1' + fields.phoneNumberInput.value.replace(/\D/g, ''),
                            LocaleId: 'en-US',
                            TermsAccepted: true,
                            RecaptchaToken: token
                        }),
                        success: () => handleAjaxSuccess(form, fields),
                        error: response => handleAjaxError(form, fields, response)
                    });
                });
        });
    });
}

function displayValidationMessage(event, fieldName, message) {
    const validationNotification = event.target.form.querySelector(`input[name=${fieldName}] + .validation-notification`)
    validationNotification.style.display = 'block'
    validationNotification.innerText = message
}

function hideValidationMessage(event, name) {

    const validationNotification = event.target.form.querySelector(`input[name=${name}] + .validation-notification`)
    validationNotification.style.display = 'none'
}

function handleInvalidPhoneNumber(event) {
    event.preventDefault()
    if (!event.target.validity.valid) {
        displayValidationMessage(event, 'phone', 'Please enter a valid phone number')
    }
}

function handleInvalidFirstName(event) {
    event.preventDefault()
    if (!event.target.validity.valid) {
        displayValidationMessage(event, 'first-name', 'Please enter your first name')
    }
}


function handleInvalidLastName(event) {
    event.preventDefault()
    if (!event.target.validity.valid) {
        displayValidationMessage(event, 'last-name', 'Please enter your last name')
    }
}

function handlePhoneNumberInput(event) {
    hideValidationMessage(event, 'phone');
}

function handleFirtsNameInput(event) {
    if (event.target.value.trim() === '') {
        event.target.value = '';
    } else {
        hideValidationMessage(event, 'first-name');
    }
}

function handleLastNameInput(event) {
    if (event.target.value.trim() === '') {
        event.target.value = '';
    } else {
        hideValidationMessage(event, 'last-name');
    }
}


function handleNoCheckedCheckbox(event) {
    if (!event.target.validity.valid) {
        event.target.classList.add('forceCheck');
    }
}

window.onload = function () {
    $('input[type=tel]').mask('(000) 000-0000');

    document.querySelector('.copyright').innerText = `Goodwrx ${currentYear}`;
    document.querySelectorAll('form')
        .forEach(handleFormSubmission);

    document.querySelectorAll('input[type=tel]')
        .forEach(inputElement => {
            inputElement.addEventListener('input', handlePhoneNumberInput);
            inputElement.addEventListener('invalid', handleInvalidPhoneNumber);
        });

    document.querySelectorAll('input[name=first-name]')
        .forEach(inputElement => {
            inputElement.addEventListener('input', handleFirtsNameInput);
            inputElement.addEventListener('invalid', handleInvalidFirstName);
        });

    document.querySelectorAll('input[name=last-name]')
        .forEach(inputElement => {
            inputElement.addEventListener('input', handleLastNameInput);
            inputElement.addEventListener('invalid', handleInvalidLastName);
        });

    document.querySelectorAll('input[type=checkbox]')
        .forEach(checkBox => {
            checkBox.addEventListener('invalid', handleNoCheckedCheckbox)
            checkBox.addEventListener('change', function () {
                if (this.checked) {
                    this.classList.remove('forceCheck');
                }
            })
        })
}
